import { render, staticRenderFns } from "./SeriesVideolist.vue?vue&type=template&id=356ddeb2&"
import script from "./SeriesVideolist.vue?vue&type=script&lang=js&"
export * from "./SeriesVideolist.vue?vue&type=script&lang=js&"
import style0 from "./SeriesVideolist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SeriesVideolist.vue"
export default component.exports